import {
  getAccessToken,
  getOktaAccessToken,
  shouldRenewAccessToken,
} from '../helpers/localStorage';
import lruCache from '../helpers/lru-request-cache';
import i18n from '@app/i18n';

const secureFileLoad = async (fileUrl) =>
  fetch(fileUrl, {
    cache: 'no-cache',
    headers: {
      // Do NOT move this ternary into a helper function
      // because nested Promises with Redux dispatch can delay API calls.
      // Safe to refactor only after migrating away from Redux.
      Authorization: shouldRenewAccessToken()
        ? await getAccessToken()
        : getOktaAccessToken(),
      'Accept-Language': i18n.language || 'en',
      'Cache-Control': 'no-cache',
      Vary: 'Authorization',
    },
  });

let cache;

const globalMediaCacheFactory = async () => {
  if (!cache) {
    cache = await lruCache('media', secureFileLoad);
  }
  return cache;
};

export default globalMediaCacheFactory;
